<template>
  <div class="star-rating">
    <div class="star-rating__stars">
      <InlineSvg
        v-for="(src, index) in starSrcs"
        :key="index"
        :src="src"
        :style="{ color: iconColor }"
        class="star-rating__star"
      />
    </div>
    <span class="star-rating__score">{{ score !== null ? Number(score).toFixed(1) : '-' }}</span>
  </div>
</template>

<script>
import star00 from '../images/star00.svg';
import star02 from '../images/star02.svg';
import star04 from '../images/star04.svg';
import star06 from '../images/star06.svg';
import star08 from '../images/star08.svg';
import star10 from '../images/star10.svg';

const STAR_SRCS = { star00, star02, star04, star06, star08, star10 };

const MAX_STARS = 5;

export default {
  name: 'StarRating',
  props: {
    // overall_score はAPIから文字列で渡ってくるため String | Number どちらも受け付ける
    score: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    numericScore() {
      if (this.score === null || this.score === undefined) return null;
      const n = Number(this.score);
      return Number.isNaN(n) ? null : n;
    },
    iconColor() {
      const s = this.numericScore;
      if (s === null) return '#707070';
      if (s === 0) return '#eceff1';
      if (s >= 4.5) return '#ff7020';
      if (s >= 4.0) return '#ffa620';
      return '#ffe660';
    },
    starSrcs() {
      const s = this.numericScore;
      if (s === null) return Array(MAX_STARS).fill(STAR_SRCS.star00);

      const srcs = [];
      const integerPart = Math.floor(s);
      const decimalPart = s - integerPart;

      for (let i = 0; i < MAX_STARS; i++) {
        if (i < integerPart) {
          srcs.push(STAR_SRCS.star10);
        } else if (i === integerPart && decimalPart > 0) {
          if (decimalPart >= 0.7) srcs.push(STAR_SRCS.star08);
          else if (decimalPart >= 0.5) srcs.push(STAR_SRCS.star06);
          else if (decimalPart >= 0.3) srcs.push(STAR_SRCS.star04);
          else if (decimalPart >= 0.1) srcs.push(STAR_SRCS.star02);
          else srcs.push(STAR_SRCS.star00);
        } else {
          srcs.push(STAR_SRCS.star00);
        }
      }

      return srcs;
    },
  },
};
</script>

<style scoped>
.star-rating {
  display: flex;
  align-items: center;
  gap: 2px;
}

.star-rating__stars {
  display: flex;
  align-items: center;
}

.star-rating__star {
  width: 14px;
  height: 14px;
}

.star-rating__score {
  font-size: 11px;
  color: #333;
  margin-left: 2px;
}
</style>
